import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import GcpFull from '../GcpFull';
const COMPONENT_NAME = 'CompanyLogoFull';
const CompanyLogoFull = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { Logo = GcpFull, ...other } = props;
    return /*#__PURE__*/ React.createElement(Logo, other);
};
CompanyLogoFull.propTypes = {
    Logo: PropTypes.elementType
};
export default CompanyLogoFull;
